import { create } from "../../../../../common/utils/zustand_state_manager";
import { InitializePaginationProperties, InitializeSetPaginationProperties, PaginationProperties, SetPaginationProperties } from "../../../../../common/utils/pagination_property";

type State = {
    clienteCentroCusto: PaginationProperties,
    clienteArquivos: PaginationProperties,
}

type Action = {
    clienteCentroCustoSetter: SetPaginationProperties,
    clienteArquivosSetter: SetPaginationProperties,
}

export const useClienteCadastroPagination = create<State & Action>((set) => ({
    clienteCentroCusto: InitializePaginationProperties({ rowsPerPage: 5 }),
    clienteCentroCustoSetter: InitializeSetPaginationProperties(set, 'clienteCentroCusto'),

    clienteArquivos: InitializePaginationProperties({ rowsPerPage: 5 }),
    clienteArquivosSetter: InitializeSetPaginationProperties(set, 'clienteArquivos'),


}));